interface AxiosError<T> {
  response?: {
    data?: {
      error: T;
    };
  };
}

function isAxiosError<T>(error: unknown): error is AxiosError<T> {
  return Boolean((error as Partial<AxiosError<T>>).response?.data?.error);
}

export { isAxiosError };
